export const urlHelper = {
  parseQueryString,
  hasHeader,
};

function parseQueryString(queryString?: string): any {
  if (!queryString) {
    queryString = window.location.search.substring(1);
  }

  const params: any = {};

  const queries = queryString.split('&');

  queries.forEach((indexQuery: string) => {
    const indexPair = indexQuery.split('=');

    const queryKey = indexPair[0];
    const queryValue = indexPair.length > 1 ? indexPair[1] : '';

    params[queryKey] = queryValue;
  });

  return params;
}

function hasHeader(pathname: string): boolean {
  return pathname !== '/redirect';
}
